import * as  common from '@/service/common';
import * as  order from '@/service/order';
import * as  shmeeting from '@/service/shmeeting';
export default {
	...common,
	...order,
	...shmeeting,
}
